import React, { createContext, useContext } from "react";

import { AnnotationSource } from "@perceptron/core/types";

const StreamSourceContext = createContext<AnnotationSource | undefined>(undefined);

export const useStreamSource = (): AnnotationSource => {
  const source = useContext(StreamSourceContext);
  if (source === undefined) {
    throw new Error("useStreamSource must be used within a StreamSourceProvider");
  }
  return source;
};

interface StreamSourceProviderProps {
  source: AnnotationSource;
  children: React.ReactNode;
}

export const StreamSourceProvider: React.FC<StreamSourceProviderProps> = ({ source, children }) => {
  return <StreamSourceContext.Provider value={source}>{children}</StreamSourceContext.Provider>;
};
